"use strict";
/**
 * @packageDocumentation
 * @module Logger.Externals
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.WithLogger = exports.LoggerBuilder = exports.LoggerOptionBuilder = exports.LoggerSettingBuilder = exports.LoggerTypeBuilder = exports.LoggerLevelBuilder = void 0;
// v2
var LoggerLevelBuilder_1 = require("./builder/LoggerLevelBuilder");
Object.defineProperty(exports, "LoggerLevelBuilder", { enumerable: true, get: function () { return LoggerLevelBuilder_1.LoggerLevelBuilder; } });
var LoggerTypeBuilder_1 = require("./builder/LoggerTypeBuilder");
Object.defineProperty(exports, "LoggerTypeBuilder", { enumerable: true, get: function () { return LoggerTypeBuilder_1.LoggerTypeBuilder; } });
var LoggerSettingBuilder_1 = require("./builder/LoggerSettingBuilder");
Object.defineProperty(exports, "LoggerSettingBuilder", { enumerable: true, get: function () { return LoggerSettingBuilder_1.LoggerSettingBuilder; } });
var LoggerOptionBuilder_1 = require("./builder/LoggerOptionBuilder");
Object.defineProperty(exports, "LoggerOptionBuilder", { enumerable: true, get: function () { return LoggerOptionBuilder_1.LoggerOptionBuilder; } });
var LoggerBuilder_1 = require("./builder/LoggerBuilder");
Object.defineProperty(exports, "LoggerBuilder", { enumerable: true, get: function () { return LoggerBuilder_1.LoggerBuilder; } });
var WithLogger_1 = require("./services/WithLogger");
Object.defineProperty(exports, "WithLogger", { enumerable: true, get: function () { return WithLogger_1.WithLogger; } });
// v1
var Logger_1 = require("./models/logger/Logger");
/**
 * @deprecated Please use LoggerBuilder instead
 */
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return Logger_1.Logger; } });
//# sourceMappingURL=index.js.map